import {
  ar,
  da,
  de,
  enGB,
  enUS,
  es,
  fr,
  hi,
  id,
  it,
  ja,
  ko,
  nb,
  nl,
  pl,
  pt,
  ptBR,
  ru,
  sv,
  tr,
  vi,
  zhCN,
  zhHK,
  zhTW,
} from 'date-fns/locale';

export const getDateFNSLocale = (locale: string) =>
  ({
    ar,
    'ar-u-nu-latn': ar,
    da,
    de,
    en: enGB,
    'en-us': enUS,
    es,
    'es-mx': es,
    fr,
    hi,
    id,
    it,
    ja,
    'jp-full': ja,
    'jp-romaji': ja,
    ko,
    nl,
    no: nb, // https://github.com/date-fns/date-fns/issues/2963
    pl,
    pt,
    'pt-br': ptBR,
    ru,
    sv,
    tr,
    vi,
    'zh-cn': zhCN,
    'zh-tw:': zhTW,
    'zh-hant': zhHK,
  })[locale];
